<template>
    <select :id="props.id" v-model="localModel" @change="handleSelectionChange">
        <option v-if="props.defaultValue !== undefined && props.defaultMessage" :value="defaultValue"
            :disabled="props.disableDefaultOption">
            {{ props.defaultMessage }}
        </option>
        <option v-else value="">Please select</option>

        <option v-for="item in props.items" :key="item.id" :value="item.id">
            {{ item.text }}
        </option>
    </select>
</template>

<script lang="ts" setup>
import { defineProps, defineEmits, ref, watch } from 'vue';

interface SelectProps {
    /**
     * Items that will be used as dropdown source
     */
    items: { id: number | string, text: number | string }[],
    id?: string,
    modelValue: any,
    defaultValue?: string | number,
    defaultMessage?: string,
    disableDefaultOption?: boolean,
    /**
     * The callback that is invoked on selection change
     */
    // eslint-disable-next-line no-unused-vars
    onChange?: (data?: any) => void
}

const props = defineProps<SelectProps>();
const emit = defineEmits(['update:modelValue']);

const localModel = ref(props.modelValue);
// watch(localModel, v => {
//     emit('update:modelValue', v);
//     if (props.onChange) {
//         props.onChange(v);
//     }
// });

const handleSelectionChange = (event: Event) => {
    const newSelectionValue = (event.target as HTMLSelectElement).value;
    emit('update:modelValue', newSelectionValue);
    if (props.onChange) {
        props.onChange(newSelectionValue);
    }
}

// parent value changes by other way
watch(props, v => localModel.value = v.modelValue);

</script>